import { render, staticRenderFns } from "./TheProductCustomizerSelector.vue?vue&type=template&id=0b8aacdf&"
import script from "./TheProductCustomizerSelector.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8aacdf')) {
      api.createRecord('0b8aacdf', component.options)
    } else {
      api.reload('0b8aacdf', component.options)
    }
    module.hot.accept("./TheProductCustomizerSelector.vue?vue&type=template&id=0b8aacdf&", function () {
      api.rerender('0b8aacdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerSelector.vue"
export default component.exports